export * from './loading.component'